const init = function () {
    const pageId = document.querySelector('[data-page="inventory"]');
    if (!pageId) {
        return;
    }

    const btnAutoMarkup = document.getElementById('btnAutoMarkup');

    btnAutoMarkup.addEventListener('click', function () {
        const zakup = parseFloat(document.getElementById('Zakup_Cena_grn').value) || 0;
        const koef = parseFloat(document.getElementById('Koef').value) || 0;
        if (zakup > 0 && koef > 0) {
            const set1 = zakup * (1 + koef / 100);
            const set2 = set1 * 0.95; // Just an example logic matching image look (strip is cheaper)
            document.querySelector('input[name="Cena_1_grn"]').value = set1.toFixed(2);
            document.querySelector('input[name="Cena_2_grn"]').value = set2.toFixed(2);
        }
    });
}
export default {init};
